/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".menu[_ngcontent-%COMP%]{padding:0 25px}\n/*# sourceMappingURL=desktop-header.component.css.map*/"];
export { styles as styles };
